import {Component, Input} from "@angular/core";
import {PromocionInfo} from "../../core/promociones/promocion-info";
import {ReferInfo} from "../../core/referrals/refer-info";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {ReferralsService} from "../../core/referrals/referrals.service";

@Component(
    {
        selector: 'app-ngbd-modal-content',
        template: `
            <div class="modal-header">
                <h4 class="modal-title">Refers</h4>
                <button type="button" class="close" aria-label="Close" [disabled]="loading" (click)="activeModal.dismiss('Cross click')">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                ¿ Está seguro que quiere
                <span class="font-weight-bold">{{refer.active ? 'DESACTIVAR' : 'ACTIVAR'}}</span> el refer:
                <span class="font-weight-bold">{{refer.name}}</span> ?
            </div>
            <div class="modal-footer">
                <div>
                    <button type="button" class="btn btn-danger" [disabled]="loading" (click)="activeModal.close('Close click')">Cancelar
                    </button>
                    <button type="button" class="btn btn-primary ml-2" [ladda]="loading" (click)="changeStatusRefer()">Aceptar</button>
                </div>
            </div>
        `
    }
)

export class ActivationReferModalComponent {
    @Input() refer: ReferInfo;
    loading = false;

    constructor(public activeModal: NgbActiveModal, public refersService: ReferralsService) {
    }

    changeStatusRefer() {
        this.loading = true;
        this.refersService.activeRefer(this.refer).subscribe(
            () => {
                this.refer.active = !this.refer.active;
                this.activeModal.close();
                this.loading = false;
            },
            () => {
                this.loading = false;
            }
        );
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/referrals/activation-refer-modal-component.ts